import React from "react";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css"; 
import image from "../../assets/images/party.png"; 

const ThankYouPage = () => {
  return (
    <PageWrapper>
      <div className="signup-page-container" style={{marginTop: "-60px"}}>
        <div className="thank-you-page-container">
          <div className="thank-you-image-container">
            <img src={image} alt="Thank You" className="thank-you-image" />
          </div>
          <p className="thank-you-heading">
            Thank you for your purchase.
          </p>
          <p className="thank-you-description" style={{lineHeight: "normal"}}>
            Please check your inbox for updates about next steps and delivery.
          </p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ThankYouPage;
